import ProviderApp from "./core/providers/provider.app";
import ServiceStorage from "./core/services/service.storage";
import { HelmetProvider } from "react-helmet-async";
import {
  useLocation,
  matchPath,
  useSearchParams,
} from "react-router-dom"
import { Suspense, useMemo } from "react";
import HeaderNav from "./ui/components/Header/Header";
import FooterNav from "./ui/components/Footer/Footer";
import ScrollToTop from "./ui/components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import "./ui/views/_layout/sitemap.xml"


function Layout({ children }) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  // لیست مسیرهایی که نمیخواهید HeaderNav و FooterNav را نمایش دهند
  const noHeaderFooterRoutes = useMemo(() => ["/ticket/:id"], []); // مسیرهای خاص بدون Header و Footer
  //const showHeaderFooter = !noHeaderFooterRoutes.includes(location.pathname);
  const showHeaderFooter = useMemo(() => !noHeaderFooterRoutes.some((route) =>
    matchPath(route, location.pathname)
  ), [location, matchPath, noHeaderFooterRoutes]);
  //Set PromoCode that is on the queryString to localStorage
  if (searchParams.get("prc") != null) {
    ServiceStorage.setPromoCode(searchParams.get("prc"));
  }
  //console.log("document.referrer:", document.referrer);
  //console.log("location.href:", window.location.href);
  //console.log("referrer policy:", document.referrerPolicy);
  //const sessionId = crypto.randomUUID();
  //console.log("sessionId",sessionId);

  //--------------------------------------------
  return (
    <ProviderApp>
      <HelmetProvider>
        <Suspense fallback={null}>
          <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
            {showHeaderFooter && <HeaderNav />}
            <div className="main-content">
              {children}
            </div>
            {showHeaderFooter && <FooterNav />}
          </div>
          <ScrollToTop />
          <ToastContainer rtl={true} />
        </Suspense>
      </HelmetProvider>
    </ProviderApp>
  );
}

export default Layout